export var COPYRIGHT = {
  en: 'Copyright © {year} Almosafer. All Rights Reserved',
  ar: '© {year} المسافر.  جميع الحقوق محفوظة '
};
export var INFO_BLOCK = {
  en: {
    callUs: 'Call us at:',
    emailUs: 'Or you can email us at:',
    whatsappUs: 'Get support via WhatsApp:',
    findBranch: 'Find a branch'
  },
  ar: {
    callUs: 'اتصل بنا على:',
    emailUs: 'أو يمكنك مراسلتنا على البريد الإلكتروني:',
    whatsappUs: 'تواصل معنا على الوتساب:',
    findBranch: 'ابحث عن فرع'
  }
};
export var LANGUAGE = {
  EN: 'en',
  AR: 'ar'
};